import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.05 7.592l-.05.03v10.766l4-2.004V5.62l-3.942 1.967-.008.005zM16 5.632v10.752l4 1.996V7.631l-4-2zM4 5.614l4 2.01V18.39l-4-2V5.615zm5 .265v.01L3.45 3.1A1 1 0 002 4v13a1 1 0 00.55.9l6 3a1 1 0 00.9 0L15 18.12l5.55 2.77A1 1 0 0022 20V7a1 1 0 00-.55-.88l-6-3a1 1 0 00-.45-.107V3a1 1 0 00-.45.11L9 5.88z",
      fill: "#2d6ded"
    }
  )
), t = a;
export {
  t as default
};
